export const findOuterIndexByReportId = (devices, targetReportId) => {
    if (!Array.isArray(devices)) {
        return -1
    }

    return devices.findIndex(device => {
        // HIDDevice 的 collections 属性中包含 reportId 信息
        if (device.collections) {
            return device.collections.some(collection => {
                // 检查 inputReports
                if (collection.inputReports) {
                    return collection.inputReports.some(report =>
                        report.reportId === targetReportId
                    )
                }
                // 检查 outputReports
                if (collection.outputReports) {
                    return collection.outputReports.some(report =>
                        report.reportId === targetReportId
                    )
                }
                // 检查 featureReports
                if (collection.featureReports) {
                    return collection.featureReports.some(report =>
                        report.reportId === targetReportId
                    )
                }
                return false
            })
        }
        return false
    })
}

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

/**
 * 获取当前系统平台
 * @returns {'Windows' | 'macOS' | 'Other'}
 */
export function getOS() {
    const ua = typeof navigator !== 'undefined'
        ? navigator.userAgent
        : (typeof process !== 'undefined' ? process.platform : '');
    if (/win/i.test(ua)) return 'Windows';
    if (/mac/i.test(ua)) return 'macOS';
    return 'Other';
}

/**
 * 深拷贝函数
 * @param {any} obj 需要深拷贝的对象
 * @param {WeakMap} hash 用于存储已经拷贝过的对象，防止循环引用
 * @returns {any} 深拷贝后的对象
 */
export function deepClone(obj, hash = new WeakMap()) {
    // 处理 null 和非对象类型
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // 处理日期对象
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }

    // 处理正则对象
    if (obj instanceof RegExp) {
        return new RegExp(obj);
    }

    // 处理数组
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item, hash));
    }

    // 处理循环引用
    if (hash.has(obj)) {
        return hash.get(obj);
    }

    // 处理普通对象
    const cloneObj = Object.create(Object.getPrototypeOf(obj));
    hash.set(obj, cloneObj);

    // 递归拷贝所有属性
    for (const [key, value] of Object.entries(obj)) {
        cloneObj[key] = deepClone(value, hash);
    }

    return cloneObj;
}
export const keycodeObj = {
    "Escape": 41,
    "F1": 58,
    "F2": 59,
    "F3": 60,
    "F4": 61,
    "F5": 62,
    "F6": 63,
    "F7": 64,
    "F8": 65,
    "F9": 66,
    "F10": 67,
    "F11": 68,
    "F12": 69,
    "Backquote": 53,
    "Digit1": 30,
    "Digit2": 31,
    "Digit3": 32,
    "Digit4": 33,
    "Digit5": 34,
    "Digit6": 35,
    "Digit7": 36,
    "Digit8": 37,
    "Digit9": 38,
    "Digit0": 39,
    "Minus": 45,
    "Equal": 46,
    "Backspace": 42,
    "Tab": 43,
    "KeyQ": 20,
    "KeyW": 26,
    "KeyE": 8,
    "KeyR": 21,
    "KeyT": 23,
    "KeyY": 28,
    "KeyU": 24,
    "KeyI": 12,
    "KeyO": 18,
    "KeyP": 19,
    "BracketLeft": 47,
    "BracketRight": 48,
    "Backslash": 49,
    "CapsLock": 57,
    "KeyA": 4,
    "KeyS": 22,
    "KeyD": 7,
    "KeyF": 9,
    "KeyG": 10,
    "KeyH": 11,
    "KeyJ": 13,
    "KeyK": 14,
    "KeyL": 15,
    "Semicolon": 51,
    "Quote": 52,
    "Enter": 40,
    "ShiftLeft": 225,
    "KeyZ": 29,
    "KeyX": 27,
    "KeyC": 6,
    "KeyV": 25,
    "KeyB": 5,
    "KeyN": 17,
    "KeyM": 16,
    "Comma": 54,
    "Period": 55,
    "Slash": 56,
    "ShiftRight": 229,
    "ArrowUp": 82,
    "ControlLeft": 224,
    "MetaLeft": 227,
    "AltLeft": 226,
    "Space": 44,
    "AltRight": 230,
    "MetaRight": 101,
    "ArrowLeft": 80,
    "ArrowDown": 81,
    "ArrowRight": 79,
    "Insert": 73,
    "Home": 74,
    "PageUp": 75,
    "Delete": 76,
    "End": 77,
    "PageDown": 78,

}

// 导出逻辑
export const exportJSON = (data, filename = 'macro.json') => {
    // 获取当前设备模式
    const mode = import.meta.env.VITE_DEVICE_MODE || 'webhid'

    if (mode === 'websocket') {
        // WebSocket 模式：发送 JSON 数据到上位机
        console.log('[exportJSON] WebSocket 模式 - 发送 JSON 数据到上位机')
        try {
            // 动态导入 device store 获取实例
            import('../stores/device.js').then(module => {
                const { useDeviceStore } = module
                const deviceStore = useDeviceStore()
                // 调用 sendSaveJson 方法发送 JSON 数据
                deviceStore.sendSaveJson(data, filename)
            }).catch(err => {
                console.error('[exportJSON] 导入 device store 失败:', err)
            })
        } catch (error) {
            console.error('[exportJSON] 发送 JSON 数据失败:', error)
        }
    } else {
        // WebHID 模式：直接下载文件
        console.log('[exportJSON] WebHID 模式 - 直接下载文件')
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        URL.revokeObjectURL(url)
    }
}

// 根据传入的keycode查找对应的key
export const findKeysByCodes = (keyboard, keyCodes) => {
    if (!Array.isArray(keyboard) || !Array.isArray(keyCodes)) return [];
    const map = new Map(keyboard.map(item => [item.keyCode, item]));
    const arr = keyCodes.map(code => map.get(code)).filter(Boolean);
    return arr.map((item) => {
        return {
            key: item.name,
            keycode: item.keyCode
        }
    })
}
// 根据传入的key查找对应的keyCode
export const findCodeByKey = (keyboard, keys) => {
    if (!Array.isArray(keyboard) || !Array.isArray(keys)) return [];
    const map = new Map(keyboard.map(item => [item.name, item]))
    const arr = keys.map(key => map.get(key)).filter(Boolean);
    return arr.map((item) => {
        return {
            key: item.name,
            keycode: item.keyCode
        }
    })
}
/**
 * RGB → HSV 转换（基于提供的 C 代码逻辑）
 * @param {number} r  红色分量 0-255
 * @param {number} g  绿色分量 0-255
 * @param {number} b  蓝色分量 0-255
 * @param {number} [maxBright=255]  RGB 亮度上限（对应 RGB_MATRIX_MAXIMUM_BRIGHTNESS）
 * @returns {object}  {h: 0-255, s: 0-255, v: 0-255}
 */
export const rgbToHsv = (r, g, b, maxBright = 255) => {
    // 归一化 RGB 到 0-1
    r = Math.min(255, Math.max(0, r)) / 255;
    g = Math.min(255, Math.max(0, g)) / 255;
    b = Math.min(255, Math.max(0, b)) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;

    // V: 亮度 (0-255)，并考虑最大亮度限制
    let v = (max > maxBright / 255) ? (maxBright) : Math.round(max * 255);

    // S: 饱和度 (0-255)
    let s = (max === 0) ? 0 : Math.round((delta / max) * 255);

    // H: 色相 (0-255)
    let h = 0;
    if (delta !== 0) {
        let hue;
        if (max === r) {
            hue = 60 * (((g - b) / delta) % 6);
        } else if (max === g) {
            hue = 60 * ((b - r) / delta + 2);
        } else {
            hue = 60 * ((r - g) / delta + 4);
        }
        if (hue < 0) hue += 360;
        h = Math.round((hue / 360) * 255);
    }

    return { h: Math.min(255, h), s: Math.min(255, s), v: Math.min(255, v) };
}

/**
 * HSV → RGB 逆向转换（基于 C 代码逻辑的逆变换）
 * @param {number} h  色相 0-255
 * @param {number} s  饱和度 0-255
 * @param {number} v  亮度 0-255
 * @param {number} [maxBright=255]  RGB 最大亮度限制（对应 RGB_MATRIX_MAXIMUM_BRIGHTNESS）
 * @returns {object}  {r: 0-255, g: 0-255, b: 0-255}
 */
export const hsvToRgb = (h, s, v, maxBright = 255) => {
    // 输入范围校验
    h = Math.min(255, Math.max(0, h));
    s = Math.min(255, Math.max(0, s));
    v = Math.min(255, Math.max(0, v));

    // 1. 将 0-255 范围转换回标准范围
    const hue = (h / 255) * 360;
    const sat = s / 255;
    const val = v / 255;

    // 2. HSV → RGB 的标准算法
    const c = val * sat;  // 色度
    const x = c * (1 - Math.abs((hue / 60) % 2 - 1));
    const m = val - c;  // 匹配亮度

    let r1, g1, b1;
    if (hue < 60) {
        r1 = c; g1 = x; b1 = 0;
    } else if (hue < 120) {
        r1 = x; g1 = c; b1 = 0;
    } else if (hue < 180) {
        r1 = 0; g1 = c; b1 = x;
    } else if (hue < 240) {
        r1 = 0; g1 = x; b1 = c;
    } else if (hue < 300) {
        r1 = x; g1 = 0; b1 = c;
    } else {
        r1 = c; g1 = 0; b1 = x;
    }

    // 3. 转回 0-255 范围，应用最大亮度限制
    const maxOut = (maxBright / 255);
    return {
        r: Math.round(Math.min(255, (r1 + m) * maxOut * 255)),
        g: Math.round(Math.min(255, (g1 + m) * maxOut * 255)),
        b: Math.round(Math.min(255, (b1 + m) * maxOut * 255))
    };
}

/**
 * HSV 数组版本 → RGB 对象
 * @param {number[]} hsv  [h, s, v] 每个分量 0-255
 * @param {number} [maxBright=255]  RGB 最大亮度限制
 * @returns {object}  {r, g, b} 每个分量 0-255
 */
export const hsvArrayToRgb = ([h, s, v], maxBright = 255) => {
    return hsvToRgb(h, s, v, maxBright);
}
export function readTag(dv, off) {
    let s = '';
    for (let i = 0; i < 4; i++) s += String.fromCharCode(dv.getUint8(off + i));
    return s;
}
export function readU16(dv, off) { return (dv.getUint8(off) << 8) | dv.getUint8(off + 1); }
export function readU32(dv, off) { return ((dv.getUint8(off) << 24) | (dv.getUint8(off + 1) << 16) | (dv.getUint8(off + 2) << 8) | dv.getUint8(off + 3)) >>> 0; }